import { DashboardViewFragment } from 'generated/graphql';
import { getEmojis, OmitEmojiWhere } from 'unicode-emoji';
import { ShortMetadata } from '../types';

export const getEmojiFromDashboard = (
  dashboard?: Pick<DashboardViewFragment, 'id' | 'shortMetadata' | 'createdAt'>,
) => {
  // try to get emoji if stored as part of shortMetadata
  if (dashboard?.shortMetadata) {
    try {
      const shortMetadata: ShortMetadata = JSON.parse(dashboard.shortMetadata);
      if (shortMetadata.dashboardEmoji) {
        return shortMetadata.dashboardEmoji;
      }
    } catch {
      // do nothing, we will fallback below
    }
  }

  const omitEmojiWhere: OmitEmojiWhere = {
    category: [
      'face-emotion',
      'food-drink',
      'animals-nature',
      'person-people',
      'symbols',
      'flags',
    ],
    subgroup: ['clothing', 'household', 'other-object', 'place-religious'],
    version: ['15.0'],
  };

  const emojis = getEmojis(omitEmojiWhere);

  // get random emoji for a new unsaved dashboard
  if (!dashboard?.id) {
    const { emoji } = emojis[Math.floor(Math.random() * emojis.length)];
    return emoji;
  }

  // get an emoji based on dashboard creation date to be consistent across
  // reloads
  const { emoji } = emojis[dashboard.createdAt % emojis.length];

  return emoji;
};
